import React from 'react'
import Navbar from "../Include/Navbar";
import Footer from "../Include/Footer";
function TermsConditions() {
  return (
    <>
    <Navbar/>
    <div className="about-page">
      <div className="container">
        <h1>Terms and Conditions</h1>
        <p>Effective Date: 8th May 2026</p>
        <p className="intro">
          Welcome to <strong>Dharmiq App</strong>, a digital platform operated by{" "}
          <strong>Innosutra AI Private Limited</strong>, (“Company”, “we”, “our”,
          or “us”).
        </p>
        <p>
          By accessing or using our website https://www.example.com or any
          related services (collectively, the “Platform”), you agree to comply
          with and be bound by these Terms and Conditions. If you do not agree,
          please do not use our Platform.
        </p>
        <section className="section">
          <h2>1. Definitions</h2>
          <ul>
            <li>
              <strong>"User"</strong>, <strong>"You"</strong>,{" "}
              <strong>"Your"</strong> refers to any individual accessing or
              using the Platform.
            </li>
            <li>
              <strong>"Company"</strong>, <strong>"We"</strong>,{" "}
              <strong>"Us"</strong>, <strong>"Our"</strong> refers to Innosutra
              AI Private Limited.
            </li>
            <li>
              <strong>"Services"</strong> refers to all features, content, and
              functionalities provided through Dharmiq App.
            </li>
          </ul>
        </section>
        <section className="section">
          <h2>2. Acceptance of Terms</h2>
          <ul>
            <li>
              By using our Platform, you confirm that you are legally capable of
              entering into a binding agreement.
            </li>
            <li>
              You will comply with all applicable laws and these Terms.
            </li>
          </ul>
        </section>
        <section className="section">
          <h2>3. Use of Cookies</h2>
          <p>
            We may use cookies and similar technologies to:
          </p>
          <ul>
            <li>Improve user experience</li>
            <li>Analyze usage patterns</li>
            <li>Enable essential features</li>
          </ul>
          <p>
            By using our Platform, you consent to the use of cookies in
            accordance with our Privacy Policy.
          </p>
        </section>
        <section className="section">
          <h2>4. Intellectual Property Rights</h2>
          <p>
            All content on <strong>Dharmiq App</strong>, including but not
            limited to:
          </p>
          <ul>
            <li>Videos</li>
            <li>Graphics</li>
            <li>Text</li>
            <li>Logos</li>
            <li>Software</li>
          </ul>
          <p>
            is owned by or licensed to the Company and protected under
            applicable intellectual property laws.
          </p>
          <p>You agree NOT to:</p>
          <ul>
            <li>Copy, reproduce, or republish content</li>
            <li>Sell, rent, or sublicense content</li>
            <li>Distribute content without permission</li>
          </ul>
          <p>
            Content may only be used for personal, non-commercial purposes
            unless otherwise authorized.
          </p>
        </section>
        <section className="section">
          <h2>5. User-Generated Content</h2>
          <p>
            Certain sections of the Platform may allow users to post comments or
            content.
          </p>
          <p>By posting content, you confirm:</p>
          <ul>
            <li>You own or have rights to the content</li>
            <li>
              The content does not violate any laws or third-party rights
            </li>
            <li>
              The content is not offensive, defamatory, or unlawful
            </li>
          </ul>
          <p>
            You grant the Company a non-exclusive, worldwide, royalty-free
            license to use, reproduce, and distribute your content.
          </p>
          <p>We reserve the right to:</p>
          <ul>
            <li>Monitor user content</li>
            <li>Remove content that violates these Terms</li>
          </ul>
        </section>
        <section className="section">
          <h2>6. Third-Party Links</h2>
          <p>Our Platform may contain links to third-party websites.</p>
          <p>We:</p>
          <ul>
            <li>Do not control or endorse such websites</li>
            <li>Are not responsible for their content or practices</li>
          </ul>
          <p>
            Users access third-party links at their own risk.
          </p>
        </section>
        <section className="section">
          <h2>7. Linking to Our Platform</h2>
          <p>
            Certain organizations may link to our Platform without prior
            approval, including:
          </p>
          <ul>
            <li>Government bodies</li>
            <li>Search engines</li>
            <li>News platforms</li>
          </ul>
          <p>
            Other entities must obtain prior written permission.
          </p>
          <p>Approved links must:</p>
          <ul>
            <li>Not be misleading</li>
            <li>Not imply endorsement</li>
            <li>Fit contextually within the linking site</li>
          </ul>
          <p>
            Use of our logo or branding requires explicit permission.
          </p>
        </section>
        <section className="section">
          <h2>8. Restrictions on Framing</h2>
          <p>You may not:</p>
          <ul>
            <li>Create frames around our website</li>
            <li>Alter the visual presentation of the Platform</li>
          </ul>
          <p>without prior written consent.</p>
        </section>
        <section className="section">
          <h2>9. Content Liability</h2>
          <p>
            We are not responsible for:
          </p>
          <ul>
            <li>
              Content published on third-party websites linking to us
            </li>
          </ul>
          <p>
            You agree to defend and indemnify us against claims arising from
            your website or content.
          </p>
        </section>
        <section className="section">
          <h2>10. Modification of Terms</h2>
          <p>We reserve the right to:</p>
          <ul>
            <li>Update or modify these Terms at any time</li>
            <li>
              Continued use of the Platform after changes means you accept the
              revised Terms.
            </li>
          </ul>
        </section>
        <section className="section">
          <h2>11. Removal of Links or Content</h2>
          <p>
            If you find any content or link on our Platform objectionable, you
            may contact us.
          </p>
          <p>We may:</p>
          <ul>
            <li>Review such requests</li>
            <li>Remove content at our discretion</li>
          </ul>
          <p>
            However, we are not obligated to take action.
          </p>
        </section>
        <section className="section">
          <h2>12. Disclaimer of Warranties</h2>
          <p>
            The Platform is provided on an “as is” and “as available” basis.
          </p>
          <p>We do not guarantee:</p>
          <ul>
            <li>Accuracy of information</li>
            <li>Continuous availability</li>
            <li>Error-free operation</li>
          </ul>
        </section>
        <section className="section">
          <h2>13. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, we shall not be liable for:
          </p>
          <ul>
            <li>Any indirect or consequential damages</li>
            <li>Loss of data, revenue, or profits</li>
          </ul>
          <p>
            Nothing in these Terms limits liability where it is unlawful to do
            so.
          </p>
        </section>
        <section className="section">
          <h2>14. Governing Law</h2>
          <p>
            These Terms shall be governed by and interpreted in accordance with
            the laws of India.
          </p>
          <p>
            Any disputes shall be subject to the jurisdiction of courts located
            in Thane.
          </p>
        </section>
        <section className="section">
          <h2>15. Contact Information</h2>
          <p>
            For any questions regarding these Terms, you may contact:
          </p>
          <ul>
            <li>
              <strong>Innosutra AI Private Limited</strong>
            </li>
            <li>
              Email: info@example.com
            </li>
            <li>
              Address: Thane, Maharashtra, India
            </li>
          </ul>
        </section>
      </div>
    </div>
    <Footer/>
    </>
  )
}
export default TermsConditions